import { render, staticRenderFns } from "./Mutes.vue?vue&type=template&id=c0bc8b38"
import script from "./Mutes.vue?vue&type=script&lang=js"
export * from "./Mutes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports